import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
// import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private httplclient: HttpClient) {}
  // isLoggedIn() {
  //   return !!localStorage.getItem("token");
  // }

  getToken() {
    return localStorage.getItem("token");
  }

  //new- rajesh
  isLoggedIn(): boolean {
    return Date.now() < this.getExpiration();
  }

  getExpiration() {
    const expiration = localStorage.getItem("expires_at");
    return expiration ? parseInt(expiration, 10) : 0;
  }
}
